import { ofType } from 'redux-observable'
import { ignoreElements, tap } from 'rxjs/operators'
import { getProductTitle } from 'domain/resources'
import * as Actions from 'store/actions/index.ts'
import {
  getCurrentProduct,
  getCurrentResourceSubUniverseName,
  getCurrentResourceUniverseName,
  getDaysSinceStartSale,
  getFilteredProductsInParentScope,
  getNbSubUniversesInCatalog,
  getNbUniversesInCatalog,
  getOperationCode,
  getPriceUnit,
  getProductCallPrice,
  getProductPriceValue,
  getSaleStartTime
} from 'store/selectors'
import { track } from 'tracking/mixPanel'

const mapStateToMPEvent = (eventName, state) => {
  const operationCode = getOperationCode(state)

  if (!operationCode) { return null }

  const currentProduct = getCurrentProduct(state)
  const daysSinceStartSale = getDaysSinceStartSale(state)
  const nbSubUniverses = getNbSubUniversesInCatalog(state)
  const nbUniverses = getNbUniversesInCatalog(state)
  const products = getFilteredProductsInParentScope(state)
  const productCallPrice = getProductCallPrice(state)
  const productPriceValue = getProductPriceValue(state)
  const saleStartTime = getSaleStartTime(state)
  const subUniverseName = getCurrentResourceSubUniverseName(state)
  const universeName = getCurrentResourceUniverseName(state)
  const packagePriceUnit = getPriceUnit(state)

  return ({
    '# of References': products.length,
    '# of Sub Universes': nbSubUniverses,
    '# of Universes': nbUniverses > 1 ? nbUniverses : 0,
    'Days Since Sale Start': daysSinceStartSale,
    'Event Name': eventName,
    'Lowest Price': productCallPrice,
    'Operation Code': operationCode,
    'Product': getProductTitle(currentProduct),
    'Product ID': currentProduct?.content?.ecomm?.externalId,
    'Product Price': productPriceValue,
    'Sale Start Time': saleStartTime,
    'Under Universe': nbUniverses > 1 ? subUniverseName : '',
    'Unit': packagePriceUnit,
    'Universe': nbUniverses > 1 ? universeName : ''
  })
}

const classicStartAddToCartEpic = (
  actions$,
  state$
) => actions$.pipe(
  ofType(Actions.configurator.USE_CONFIGURATOR),
  tap(() => {
    const eventName = 'Classic Start Add To Cart'

    track(eventName, mapStateToMPEvent(eventName, state$.value), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default classicStartAddToCartEpic
